<template>
  <div class="body1" v-loading="isLoading">
    <!-- 学生数据 -->
    <div class="left">
      <div class="top">
        <div class="titleBox">
          <div class="title">基础概况</div>
        </div>
        <div class="dataBox">
          <div class="info_box">
            <div class="info blueBG">
              <span>学生总数</span>
              <span>{{ count }}</span>
            </div>
            <div class="info greenBG">
              <span>周使用频次</span>
              <span>{{weekCount}}</span>
            </div>
            <div class="info blueBG">
              <span>登录频次</span>
              <span>{{ loginCount }}</span>
            </div>
            <div class="info greenBG">
              <span>人均使用频次</span>
              <span>{{ (loginCount / count).toFixed(0) }}</span>
            </div>
          </div>
          <loginCount :monthArray="loginCountMonthArray" style="height: calc(100% - 140px)"></loginCount>
        </div>
      </div>
      <div class="bottom">
        <div class="titleBox">
          <div class="title">学生行为数据</div>
        </div>
        <div class="dataBox">
          <stuAct style="height: calc(100% - 20px)" :courseClass="courseClass"></stuAct>
        </div>
      </div>
    </div>
    <div class="center">
      <div class="top">
        <div class="titleBox">
          <div class="title">学生综合评价</div>
        </div>
        <div class="dataBox">
          <div class="info_box" style="width: 95%; justify-content: flex-start">
            <div class="info2 blueBG">
              <span>学生总数</span>
              <span>{{ count }}</span>
            </div>
            <div class="info2 greenBG">
              <span>班级总数</span>
              <span>{{classList.length}}</span>
            </div>
            <div class="info2 blueBG">
              <span>平均得分</span>
              <span>{{scoreJun}}</span>
            </div>
          </div>
          <studentInfo style="height: calc(100% - 70px)" :EscoreArray2="EscoreArray2" @openDataClass="openDataClass"></studentInfo>
        </div>
      </div>
      <div class="bottom">
        <div class="titleBox">
          <div class="title">平台使用深度</div>
        </div>
        <div class="dataBox">
          <div class="depth_box">
            <div class="depth">
              <span>参与课程</span>
              <div>
                <el-progress
                  :width="90"
                  type="circle"
                  :percentage="lightJson.course ? ((lightJson.course / count) * 100).toFixed(0) : 0"
                  :stroke-width="15"
                  :format="format"
                  color="#106BFF"
                ></el-progress>
              </div>
            </div>
            <div class="depth">
              <span>参与项目</span>
              <div>
                <el-progress
                  :width="90"
                  type="circle"
                  :percentage="lightJson.scourse ? ((lightJson.scourse / count) * 100).toFixed(0) : 0"
                  :stroke-width="15"
                  :format="format"
                  color="#106BFF"
                ></el-progress>
              </div>
            </div>
            <div class="depth">
              <span>使用工具</span>
              <div>
                <el-progress
                  :width="90"
                  type="circle"
                  :percentage="lightJson.tools ? ((lightJson.tools / count) * 100).toFixed(0) : 0"
                  :stroke-width="15"
                  :format="format"
                  color="#106BFF"
                ></el-progress>
              </div>
            </div>
            <div class="depth">
              <span>协同合作</span>
              <div>
                <el-progress
                  :width="90"
                  type="circle"
                  :percentage="lightJson.xcourse ? ((lightJson.xcourse / count) * 100).toFixed(0) : 0"
                  :stroke-width="15"
                  :format="format"
                  color="#106BFF"
                ></el-progress>
              </div>
            </div>
            <div class="depth">
              <span>互动交流</span>
              <div>
                <el-progress
                  :width="90"
                  type="circle"
                  :percentage="lightJson.exchange ? ((lightJson.exchange / count) * 100).toFixed(0) : 0"
                  :stroke-width="15"
                  :format="format"
                  color="#106BFF"
                ></el-progress>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="right">
      <div class="top">
        <div class="titleBox">
          <div class="title">学生综合评价</div>
          <el-select v-model="eva" @focus="setMinWidth" class="selectBox" style="width: 150px;">
            <el-option v-for="item in evArray" :key="item.id" :label="item.title" :value="item.id" :style="{'width': minWidth + 2 + 'px'}"></el-option>
          </el-select>
        </div>
        <div class="dataBox">
          <studentInfo2 :evCourseArray="evCourseArray" :eva="eva"></studentInfo2>
        </div>
      </div>
      <div class="bottom">
        <div class="titleBox">
          <div class="title">在线时长</div>
        </div>
        <div class="dataBox">
          <div class="info_box">
            <div class="info blueBG">
              <span>累计在线时长</span>
              <span>{{ loginTime.toFixed(0) }}小时</span>
            </div>
            <div class="info greenBG">
              <span>学生在线平均时长</span>
              <span>{{ (loginTime / count).toFixed(0) }}小时</span>
            </div>
          </div>
          <loginTime style="height: calc(100% - 70px)" :EloginTimeArray="EloginTimeArray"></loginTime>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import loginCount from "./loginCount";
import studentInfo from "./studentInfo";
import studentInfo2 from "./studentInfo2";
import loginTime from "./loginTime";
import stuAct from "./stuAct";
export default {
  props: {
    oid: {
      type: String,
    },
    org: {
      type: String,
    },
  },
  components: {
    loginCount,
    studentInfo,
    studentInfo2,
    loginTime,
    stuAct,
  },
  data() {
    return {
      isLoading: false,
      count: 0,
      loginCount: 0,
      loginTime: 0,
      loginCountMonthArray:[],
      weekCount:0,
      classList:[],
      scoreJun:0,
      evArray:[],
      eva:'',
      evCourseArray:[],
      minWidth:0,
      courseClass:[],
      lightJson: {
        course:0,
        scourse:0,
        tools:0,
        xcourse:0,
        exchange:0,
      },
      EloginTimeArray:[],
      EscoreArray2:[],
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    openDataClass(classIndex){
      console.log(classIndex);
      console.log(this.EscoreArray2[classIndex]);
      window.parent.postMessage(
        { 
          tools: "openDataClass",
          classid: this.EscoreArray2[classIndex].id,
        }, 
        "*"
      );
    },
    setMinWidth (val) {
      this.minWidth = val.srcElement.clientWidth
    },
    getData() {
      this.isLoading = true;
      let params = [
        {
          oid: this.oid,
          org: this.org,
        },
      ];
      this.ajax
        .post(this.$store.state.api + "selectDataBoardStudent", params)
        .then((res) => {
          this.isLoading = false;
          this.count = res.data[0][0].count;
          this.loginCount = res.data[1][0].loginCount;
          this.loginTime = parseInt(res.data[2][0].time) / 60 / 60;



          let loginCountMonthArray = []
          const date = new Date()
          var Month = date.getMonth() + 1
          var Year = date.getFullYear()
          for (var i = Month; i > Month - 6; i--) {
            if (i <= 0) {
              loginCountMonthArray.push({
                Year: Year - 1,
                Month: 12 + i,
                student: 0,
              })
            } else {
              loginCountMonthArray.push({
                Month: i,
                Year: Year,
                student: 0,
              })
            }
          }

          loginCountMonthArray = loginCountMonthArray.reverse()
          let studentLoginCountYear = res.data[3] // 学生半年登录次数统计

          for (var i = 0; i < studentLoginCountYear.length; i++) {
            let _date = new Date(studentLoginCountYear[i].create_at)
            var _month = _date.getMonth() + 1
            var _year = _date.getFullYear()
            for (var j = 0; j < loginCountMonthArray.length; j++) {
              if (_month == loginCountMonthArray[j].Month && _year == loginCountMonthArray[j].Year) {
                loginCountMonthArray[j].student++
                break;
              }
            }
          }
          this.loginCountMonthArray = loginCountMonthArray;
          console.log(loginCountMonthArray);

          this.weekCount = res.data[4][0].count
          let _classList = res.data[5]
          this.classList = _classList
          let _scoreArray = res.data[6]
          let _sumScore = 0
          for(var i = 0; i< _scoreArray.length;i++){
            let _score = JSON.parse(_scoreArray[i].score)
            _sumScore += _score.wScore
          }
          this.scoreJun = (_sumScore / _scoreArray.length).toFixed(0)


          let _evArray = res.data[7] //目标数组
          let _evWorkArray = res.data[8] //目标课程的作业
          let _evCourseArray = [] //计算总分 
          let _evCourse = [] //筛选有目标的数组 
          for(var i = 0;i<_evWorkArray.length;i++){
              let courseJson = JSON.parse(_evWorkArray[i].chapters)
              let _rate = JSON.parse(_evWorkArray[i].rate)
              delete _rate.content
              if(courseJson[_evWorkArray[i].stage] && 
                courseJson[_evWorkArray[i].stage].chapterInfo[0].taskJson[_evWorkArray[i].task] && 
                courseJson[_evWorkArray[i].stage].chapterInfo[0].taskJson[_evWorkArray[i].task].eList &&
                courseJson[_evWorkArray[i].stage].chapterInfo[0].taskJson[_evWorkArray[i].task].eList.length){
                let _elist = courseJson[_evWorkArray[i].stage].chapterInfo[0].taskJson[_evWorkArray[i].task].eList
                let _rateC = Object.keys(_rate)
                let json = {}
                for(var j = 0;j<_rateC.length;j++){
                  for(var k = 0;k<_elist.length;k++){
                    if(_elist[k].value == _rateC[j] && _elist[k].target){
                      json[_elist[k].target[0]] = _rate[_rateC[j]]
                      break;
                    }
                  }
                }
                if(Object.keys(json).length){
                  _evCourse.push({
                    evid:_evWorkArray[i].evaId,
                    rateJson:json
                  })
                }
              }
          }
          for(var i = 0;i<_evArray.length;i++){
            _evCourseArray.push({
              title:_evArray[i].title,
              evid:_evArray[i].id,
              evJson:{}
            })
            for(var j = 0;j<_evCourse.length;j++){
              if(_evArray[i].id == _evCourse[j].evid){
                let _rate = Object.keys(_evCourse[j].rateJson)
                for(var k = 0;k<_rate.length;k++){
                  if(_evCourseArray[i].evJson[_rate[k]]){
                    _evCourseArray[i].evJson[_rate[k]].push(_evCourse[j].rateJson[_rate[k]])
                  }else{
                    _evCourseArray[i].evJson[_rate[k]] = [_evCourse[j].rateJson[_rate[k]]]
                  }
                }
              }
            }
          }
          for(var i = 0;i < _evCourseArray.length; i++){
            _evCourseArray[i].indicator = []
            _evCourseArray[i].value = []
            let evJson = Object.keys(_evCourseArray[i].evJson)
            for(var j = 0;j < evJson.length;j++){
              _evCourseArray[i].indicator.push({
                name:evJson[j],
                max: 5 
              })
              let sum = 0
              _evCourseArray[i].evJson[evJson[j]].forEach((value)=>{
                sum+=value
              })
              _evCourseArray[i].value.push((sum / _evCourseArray[i].evJson[evJson[j]].length).toFixed(1))
            }
          }
          this.evArray = _evArray
          this.eva = _evArray[0].id
          this.evCourseArray = _evCourseArray

          let _courseClassArray = res.data[9] //作业带课程
          let _courseClass = []
          for(var i = 0;i<_classList.length;i++){
            _courseClass.push({
              name:_classList[i].name,
              works:0,
              id:_classList[i].id
            })
            for(var j = 0;j<_courseClassArray.length;j++){
              if(_courseClassArray[j].classid.indexOf(_classList[i].id) != -1){
                _courseClass[i].works++
              }
            }
          }
          this.courseClass = _courseClass

          let _lcourse = res.data[10][0].num //参与课程数量
          let _lscourse = res.data[11][0].num //参与项目
          let _ltools = res.data[12][0].num //使用工具
          let _lxcourse = res.data[13][0].num //协同合作
          let _lexchange = res.data[14][0].num //互动交流

          this.lightJson = {
            course:_lcourse,
            scourse:_lscourse,
            tools:_ltools,
            xcourse:_lxcourse,
            exchange:_lexchange,
          }

          let _loginTimeArray = res.data[15] //在线时间
          let _scoreArray2 = res.data[16] //得分


          let _EloginTimeArray = []
          for (let i = 0; i < _classList.length; i++) {
            _EloginTimeArray.push({
              id:_classList[i].id,
              name:_classList[i].name,
              loginTime:0
            })
            for (let j = 0; j < _loginTimeArray.length; j++) {
              const _user = _loginTimeArray[j];
              if(_user.classid.indexOf(_classList[i].id) != -1){
                _EloginTimeArray[i].loginTime += Number(_user.time)
              }
            }
            _EloginTimeArray[i].loginTime = (_EloginTimeArray[i].loginTime / 60 / 60).toFixed(2) //换算成小时
          }
          this.EloginTimeArray = _EloginTimeArray
          let _EscoreArray2 = []
          for (let i = 0; i < _classList.length; i++) {
            _EscoreArray2.push({
              id:_classList[i].id,
              name:_classList[i].name,
              max:0,
              min:0,
              score:[]
            })
            for (let j = 0; j < _scoreArray2.length; j++) {
              const _user = _scoreArray2[j];
              if(_user.classid.indexOf(_classList[i].id) != -1){
                _EscoreArray2[i].score.push(_user.score)
              }
            }
            if(_EscoreArray2[i].score.length){
              _EscoreArray2[i].score = _EscoreArray2[i].score.sort((i, j) => {
                return i-j; 
              })
              _EscoreArray2[i].max = _EscoreArray2[i].score[_EscoreArray2[i].score.length-1]
              _EscoreArray2[i].min = _EscoreArray2[i].score[0]
            }
          }
          this.EscoreArray2 = _EscoreArray2
        })
        .catch((err) => {
          this.isLoading = false;
          console.error(err);
        });
    },
    format(percentage) {
      return percentage + '%';
    },
  },
};
</script>


<style scoped>
.body1 {
  width: 100%;
  height: 100%;
  display: flex;
  padding: 20px;
  box-sizing: border-box;
  overflow: hidden;
}

.left {
  width: calc(100% / 4 * 1);
  height: 100%;
}

.left > .top {
  width: 100%;
  height: calc(100% / 2 - 10px);
  background: #fff;
  border-radius: 5px;
  margin: 0 0 20px 0;
}

.left > .bottom {
  width: 100%;
  height: calc(100% / 2 - 10px);
  background: #fff;
  border-radius: 5px;
}

.center {
  width: calc(100% / 4 * 2 - 40px);
  height: 100%;
  margin: 0 20px;
}

.center > .top {
  width: 100%;
  height: calc(100% / 6 * 4 - 10px);
  background: #fff;
  border-radius: 5px;
  margin: 0 0 20px 0;
}

.center > .bottom {
  width: 100%;
  height: calc(100% / 6 * 2 - 10px);
  background: #fff;
  border-radius: 5px;
}

.right {
  width: calc(100% / 4 * 1);
  height: 100%;
}

.right > .top {
  width: 100%;
  height: calc(100% / 2 - 10px);
  background: #fff;
  border-radius: 5px;
  margin: 0 0 20px 0;
}

.right > .bottom {
  width: 100%;
  height: calc(100% / 2 - 10px);
  background: #fff;
  border-radius: 5px;
}

.titleBox {
  height: 40px;
  display: flex;
  align-items: center;
  padding: 0 15px;
  width: 100%;
}

.dataBox {
  height: calc(100% - 40px);
  width: 100%;
}

.titleBox {
  height: 40px;
  display: flex;
  align-items: center;
  padding: 0 15px;
  width: 100%;
}

.titleBox > .title {
  font-weight: 700;
}

.dataBox {
  height: calc(100% - 40px);
  width: 100%;
}

.info_box {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  width: 90%;
  margin: 0 auto;
}

.info_box > .info2,
.info_box > .info3,
.info_box > .info {
  width: calc(50% - 10px);
  display: flex;
  flex-direction: column;
  height: 60px;
  justify-content: center;
  padding: 0 10px;
  box-sizing: border-box;
  margin-bottom: 10px;
  border-radius: 5px;
}

.info_box > .info2 {
  width: calc(100% / 4 - 10px);
  align-items: flex-end;
  margin-right: 10px;
}

.info_box > .info3 {
  width: 100%;
  margin-bottom: 5px;
}

.info_box > .info2 > span:nth-child(1),
.info_box > .info3 > span:nth-child(1),
.info_box > .info > span:nth-child(1) {
  font-size: 12px;
  /* margin: 0 0 5px 0; */
  color: #565e6a;
}

.info_box > .info2 > span:nth-child(2),
.info_box > .info3 > span:nth-child(2),
.info_box > .info > span:nth-child(2) {
  font-size: 22px;
  font-weight: 700;
}

.blueBG {
  background: linear-gradient(
    180deg,
    rgba(224, 234, 251, 0.2) 0%,
    rgba(54, 130, 252, 0.3) 100%
  );
}

.greenBG {
  background: linear-gradient(
    180deg,
    rgb(211, 246, 228, 0.2) 0%,
    rgb(23, 196, 105, 0.3) 100%
  );
}

.depth_box {
  display: flex;
  flex-wrap: wrap;
  height: 100%;
  width: 95%;
  margin: 0 auto;
  overflow: hidden;
  justify-content: space-between;
}

.depth {
  width: calc(100% / 5 - 10px);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.depth > span:nth-child(1) {
  font-size: 14px;
  font-weight: 700;
  margin: 0 0 10px;
}
.depth > div:nth-child(1) {
}

.selectBox {
  width: 80px;
  margin-left: 10px;
}

.selectBox>>>.el-input__inner {
  height: 30px;
  line-height: 30px;
}

.selectBox>>>.el-input__icon {
  line-height: 30px;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/dataBoard/student/index.vue